import { render, staticRenderFns } from "./chat-sidebar-groups.vue?vue&type=template&id=f603a8ec&scoped=true&"
import script from "./chat-sidebar-groups.vue?vue&type=script&lang=js&"
export * from "./chat-sidebar-groups.vue?vue&type=script&lang=js&"
import style0 from "./chat-sidebar-groups.vue?vue&type=style&index=0&id=f603a8ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f603a8ec",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f603a8ec')) {
      api.createRecord('f603a8ec', component.options)
    } else {
      api.reload('f603a8ec', component.options)
    }
    module.hot.accept("./chat-sidebar-groups.vue?vue&type=template&id=f603a8ec&scoped=true&", function () {
      api.rerender('f603a8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-sidebar-groups/chat-sidebar-groups.vue"
export default component.exports